var _clipPath;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "93b69cd127"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 375 187.5 C 375 190.570312 374.925781 193.636719 374.773438 196.699219 C 374.625 199.765625 374.398438 202.824219 374.097656 205.878906 C 373.796875 208.933594 373.421875 211.976562 372.96875 215.011719 C 372.519531 218.046875 371.996094 221.070312 371.398438 224.078125 C 370.796875 227.089844 370.125 230.082031 369.378906 233.058594 C 368.636719 236.035156 367.816406 238.992188 366.925781 241.929688 C 366.035156 244.863281 365.074219 247.777344 364.039062 250.667969 C 363.003906 253.554688 361.902344 256.417969 360.726562 259.253906 C 359.554688 262.089844 358.308594 264.890625 356.996094 267.667969 C 355.6875 270.441406 354.308594 273.179688 352.859375 275.886719 C 351.414062 278.59375 349.902344 281.261719 348.324219 283.894531 C 346.746094 286.527344 345.105469 289.117188 343.402344 291.667969 C 341.695312 294.222656 339.929688 296.730469 338.101562 299.195312 C 336.273438 301.660156 334.386719 304.078125 332.4375 306.449219 C 330.492188 308.820312 328.488281 311.144531 326.429688 313.417969 C 324.367188 315.691406 322.253906 317.914062 320.082031 320.082031 C 317.914062 322.253906 315.691406 324.367188 313.417969 326.429688 C 311.144531 328.488281 308.820312 330.492188 306.449219 332.4375 C 304.078125 334.386719 301.660156 336.273438 299.195312 338.101562 C 296.730469 339.929688 294.222656 341.695312 291.667969 343.402344 C 289.117188 345.105469 286.527344 346.746094 283.894531 348.324219 C 281.261719 349.902344 278.59375 351.414062 275.886719 352.859375 C 273.179688 354.308594 270.441406 355.6875 267.667969 356.996094 C 264.894531 358.308594 262.089844 359.554688 259.253906 360.726562 C 256.417969 361.902344 253.554688 363.003906 250.667969 364.039062 C 247.777344 365.074219 244.863281 366.035156 241.929688 366.925781 C 238.992188 367.816406 236.035156 368.636719 233.058594 369.378906 C 230.082031 370.125 227.089844 370.796875 224.078125 371.398438 C 221.070312 371.996094 218.046875 372.519531 215.011719 372.96875 C 211.976562 373.421875 208.933594 373.796875 205.878906 374.097656 C 202.824219 374.398438 199.765625 374.625 196.699219 374.773438 C 193.636719 374.925781 190.570312 375 187.5 375 C 184.429688 375 181.363281 374.925781 178.300781 374.773438 C 175.234375 374.625 172.175781 374.398438 169.121094 374.097656 C 166.066406 373.796875 163.023438 373.421875 159.988281 372.96875 C 156.953125 372.519531 153.929688 371.996094 150.921875 371.398438 C 147.910156 370.796875 144.917969 370.125 141.941406 369.378906 C 138.964844 368.636719 136.007812 367.816406 133.070312 366.925781 C 130.136719 366.035156 127.222656 365.074219 124.332031 364.039062 C 121.445312 363.003906 118.582031 361.902344 115.746094 360.726562 C 112.910156 359.554688 110.105469 358.308594 107.332031 356.996094 C 104.558594 355.6875 101.820312 354.308594 99.113281 352.859375 C 96.40625 351.414062 93.738281 349.902344 91.105469 348.324219 C 88.472656 346.746094 85.882812 345.105469 83.332031 343.402344 C 80.777344 341.695312 78.269531 339.929688 75.804688 338.101562 C 73.339844 336.273438 70.921875 334.386719 68.550781 332.4375 C 66.179688 330.492188 63.855469 328.488281 61.582031 326.429688 C 59.308594 324.367188 57.085938 322.253906 54.917969 320.082031 C 52.746094 317.914062 50.632812 315.691406 48.570312 313.417969 C 46.511719 311.144531 44.507812 308.820312 42.558594 306.449219 C 40.613281 304.078125 38.726562 301.660156 36.898438 299.195312 C 35.070312 296.730469 33.304688 294.222656 31.597656 291.667969 C 29.894531 289.117188 28.253906 286.527344 26.675781 283.894531 C 25.097656 281.261719 23.585938 278.59375 22.140625 275.886719 C 20.691406 273.179688 19.3125 270.441406 18.003906 267.667969 C 16.691406 264.890625 15.445312 262.089844 14.273438 259.253906 C 13.097656 256.417969 11.996094 253.554688 10.960938 250.667969 C 9.925781 247.777344 8.964844 244.863281 8.074219 241.929688 C 7.183594 238.992188 6.363281 236.035156 5.621094 233.058594 C 4.875 230.082031 4.203125 227.089844 3.601562 224.078125 C 3.003906 221.070312 2.480469 218.046875 2.03125 215.011719 C 1.578125 211.976562 1.203125 208.933594 0.902344 205.878906 C 0.601562 202.824219 0.375 199.765625 0.226562 196.699219 C 0.0742188 193.636719 0 190.570312 0 187.5 C 0 184.429688 0.0742188 181.363281 0.226562 178.300781 C 0.375 175.234375 0.601562 172.175781 0.902344 169.121094 C 1.203125 166.066406 1.578125 163.023438 2.03125 159.988281 C 2.480469 156.953125 3.003906 153.929688 3.601562 150.921875 C 4.203125 147.910156 4.875 144.917969 5.621094 141.941406 C 6.363281 138.964844 7.183594 136.007812 8.074219 133.070312 C 8.964844 130.136719 9.925781 127.222656 10.960938 124.332031 C 11.996094 121.445312 13.097656 118.582031 14.273438 115.746094 C 15.445312 112.910156 16.691406 110.105469 18.003906 107.332031 C 19.3125 104.558594 20.691406 101.820312 22.140625 99.113281 C 23.585938 96.40625 25.097656 93.738281 26.675781 91.105469 C 28.253906 88.472656 29.894531 85.882812 31.597656 83.332031 C 33.304688 80.777344 35.070312 78.269531 36.898438 75.804688 C 38.726562 73.339844 40.613281 70.921875 42.558594 68.550781 C 44.507812 66.179688 46.511719 63.855469 48.570312 61.582031 C 50.632812 59.308594 52.746094 57.085938 54.917969 54.917969 C 57.085938 52.746094 59.308594 50.632812 61.582031 48.570312 C 63.855469 46.511719 66.179688 44.507812 68.550781 42.558594 C 70.921875 40.613281 73.339844 38.726562 75.804688 36.898438 C 78.269531 35.070312 80.777344 33.304688 83.332031 31.597656 C 85.882812 29.894531 88.472656 28.253906 91.105469 26.675781 C 93.738281 25.097656 96.40625 23.585938 99.113281 22.140625 C 101.820312 20.691406 104.558594 19.3125 107.332031 18.003906 C 110.105469 16.691406 112.910156 15.445312 115.746094 14.273438 C 118.582031 13.097656 121.445312 11.996094 124.332031 10.960938 C 127.222656 9.925781 130.136719 8.964844 133.070312 8.074219 C 136.007812 7.183594 138.964844 6.363281 141.941406 5.617188 C 144.917969 4.875 147.910156 4.203125 150.921875 3.601562 C 153.929688 3.003906 156.953125 2.480469 159.988281 2.03125 C 163.023438 1.578125 166.066406 1.203125 169.121094 0.902344 C 172.175781 0.601562 175.234375 0.375 178.300781 0.226562 C 181.363281 0.0742188 184.429688 0 187.5 0 C 190.570312 0 193.636719 0.0742188 196.699219 0.226562 C 199.765625 0.375 202.824219 0.601562 205.878906 0.902344 C 208.933594 1.203125 211.976562 1.578125 215.011719 2.03125 C 218.046875 2.480469 221.070312 3.003906 224.078125 3.601562 C 227.089844 4.203125 230.082031 4.875 233.058594 5.617188 C 236.035156 6.363281 238.992188 7.183594 241.929688 8.074219 C 244.863281 8.964844 247.777344 9.925781 250.667969 10.960938 C 253.554688 11.996094 256.417969 13.097656 259.253906 14.273438 C 262.089844 15.445312 264.894531 16.691406 267.667969 18.003906 C 270.441406 19.3125 273.179688 20.691406 275.886719 22.140625 C 278.59375 23.585938 281.261719 25.097656 283.894531 26.675781 C 286.527344 28.253906 289.117188 29.894531 291.667969 31.597656 C 294.222656 33.304688 296.730469 35.070312 299.195312 36.898438 C 301.660156 38.726562 304.078125 40.613281 306.449219 42.558594 C 308.820312 44.507812 311.144531 46.511719 313.417969 48.570312 C 315.691406 50.632812 317.914062 52.746094 320.082031 54.917969 C 322.253906 57.085938 324.367188 59.308594 326.429688 61.582031 C 328.488281 63.855469 330.492188 66.179688 332.4375 68.550781 C 334.386719 70.921875 336.273438 73.339844 338.101562 75.804688 C 339.929688 78.269531 341.695312 80.777344 343.402344 83.332031 C 345.105469 85.882812 346.746094 88.472656 348.324219 91.105469 C 349.902344 93.738281 351.414062 96.40625 352.859375 99.113281 C 354.308594 101.820312 355.6875 104.558594 356.996094 107.332031 C 358.308594 110.105469 359.554688 112.910156 360.726562 115.746094 C 361.902344 118.582031 363.003906 121.445312 364.039062 124.332031 C 365.074219 127.222656 366.035156 130.136719 366.925781 133.070312 C 367.816406 136.007812 368.636719 138.964844 369.378906 141.941406 C 370.125 144.917969 370.796875 147.910156 371.398438 150.921875 C 371.996094 153.929688 372.519531 156.953125 372.96875 159.988281 C 373.421875 163.023438 373.796875 166.066406 374.097656 169.121094 C 374.398438 172.175781 374.625 175.234375 374.773438 178.300781 C 374.925781 181.363281 375 184.429688 375 187.5 Z M 375 187.5 "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.0499028,
    gradientTransform: "matrix(1.221498,0,0,1.221498,0.0000045,0)",
    y1: 307.049891,
    x2: 307.050596,
    gradientUnits: "userSpaceOnUse",
    y2: 0.0506091,
    id: "9052c2a439"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fec053",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fec053",
      stopOpacity: 1
    },
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fec053",
      stopOpacity: 1
    },
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#febf53",
      stopOpacity: 1
    },
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#febf53",
      stopOpacity: 1
    },
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#febd53",
      stopOpacity: 1
    },
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#febb52",
      stopOpacity: 1
    },
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#feb952",
      stopOpacity: 1
    },
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdb752",
      stopOpacity: 1
    },
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdb652",
      stopOpacity: 1
    },
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdb451",
      stopOpacity: 1
    },
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdb251",
      stopOpacity: 1
    },
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdb051",
      stopOpacity: 1
    },
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdae51",
      stopOpacity: 1
    },
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdac50",
      stopOpacity: 1
    },
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcaa50",
      stopOpacity: 1
    },
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fca950",
      stopOpacity: 1
    },
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fca750",
      stopOpacity: 1
    },
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fca54f",
      stopOpacity: 1
    },
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fca34f",
      stopOpacity: 1
    },
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fca14f",
      stopOpacity: 1
    },
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fc9f4f",
      stopOpacity: 1
    },
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fb9d4e",
      stopOpacity: 1
    },
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fb9b4e",
      stopOpacity: 1
    },
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fb9a4e",
      stopOpacity: 1
    },
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fb984e",
      stopOpacity: 1
    },
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fb964d",
      stopOpacity: 1
    },
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fb944d",
      stopOpacity: 1
    },
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fb924d",
      stopOpacity: 1
    },
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fa904d",
      stopOpacity: 1
    },
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fa8e4c",
      stopOpacity: 1
    },
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fa8c4c",
      stopOpacity: 1
    },
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fa8b4c",
      stopOpacity: 1
    },
    offset: 0.257813
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fa894c",
      stopOpacity: 1
    },
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fa874b",
      stopOpacity: 1
    },
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fa854b",
      stopOpacity: 1
    },
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9834b",
      stopOpacity: 1
    },
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9814b",
      stopOpacity: 1
    },
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f97f4b",
      stopOpacity: 1
    },
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f97d4a",
      stopOpacity: 1
    },
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f97c4a",
      stopOpacity: 1
    },
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f97a4a",
      stopOpacity: 1
    },
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9784a",
      stopOpacity: 1
    },
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f87649",
      stopOpacity: 1
    },
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f87449",
      stopOpacity: 1
    },
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f87249",
      stopOpacity: 1
    },
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f87049",
      stopOpacity: 1
    },
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f86e48",
      stopOpacity: 1
    },
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f86d48",
      stopOpacity: 1
    },
    offset: 0.320313
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f86b48",
      stopOpacity: 1
    },
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f76948",
      stopOpacity: 1
    },
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f76747",
      stopOpacity: 1
    },
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f76547",
      stopOpacity: 1
    },
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f76347",
      stopOpacity: 1
    },
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f76147",
      stopOpacity: 1
    },
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f75f46",
      stopOpacity: 1
    },
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f75e46",
      stopOpacity: 1
    },
    offset: 0.351563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f65c46",
      stopOpacity: 1
    },
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f65a46",
      stopOpacity: 1
    },
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f65845",
      stopOpacity: 1
    },
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f65645",
      stopOpacity: 1
    },
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f65445",
      stopOpacity: 1
    },
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f65245",
      stopOpacity: 1
    },
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f65044",
      stopOpacity: 1
    },
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f54f44",
      stopOpacity: 1
    },
    offset: 0.382813
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f54d44",
      stopOpacity: 1
    },
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f54b44",
      stopOpacity: 1
    },
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f54943",
      stopOpacity: 1
    },
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f54743",
      stopOpacity: 1
    },
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f54543",
      stopOpacity: 1
    },
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f54343",
      stopOpacity: 1
    },
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f54142",
      stopOpacity: 1
    },
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f44042",
      stopOpacity: 1
    },
    offset: 0.414063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f43e42",
      stopOpacity: 1
    },
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f43c42",
      stopOpacity: 1
    },
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f43a41",
      stopOpacity: 1
    },
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f43841",
      stopOpacity: 1
    },
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f43641",
      stopOpacity: 1
    },
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f43441",
      stopOpacity: 1
    },
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f33240",
      stopOpacity: 1
    },
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f33140",
      stopOpacity: 1
    },
    offset: 0.445313
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f32f40",
      stopOpacity: 1
    },
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f32d40",
      stopOpacity: 1
    },
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f32b3f",
      stopOpacity: 1
    },
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3293f",
      stopOpacity: 1
    },
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3273f",
      stopOpacity: 1
    },
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2253f",
      stopOpacity: 1
    },
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2233e",
      stopOpacity: 1
    },
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2223e",
      stopOpacity: 1
    },
    offset: 0.476563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1213f",
      stopOpacity: 1
    },
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f02041",
      stopOpacity: 1
    },
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ef2043",
      stopOpacity: 1
    },
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ee2046",
      stopOpacity: 1
    },
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ec2048",
      stopOpacity: 1
    },
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eb204a",
      stopOpacity: 1
    },
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ea204d",
      stopOpacity: 1
    },
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8204f",
      stopOpacity: 1
    },
    offset: 0.507813
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e72052",
      stopOpacity: 1
    },
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e62054",
      stopOpacity: 1
    },
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e42057",
      stopOpacity: 1
    },
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e32059",
      stopOpacity: 1
    },
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2205b",
      stopOpacity: 1
    },
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0205e",
      stopOpacity: 1
    },
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#df2060",
      stopOpacity: 1
    },
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#de2063",
      stopOpacity: 1
    },
    offset: 0.539063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dc2065",
      stopOpacity: 1
    },
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#db2068",
      stopOpacity: 1
    },
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9206a",
      stopOpacity: 1
    },
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8206d",
      stopOpacity: 1
    },
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7206f",
      stopOpacity: 1
    },
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d52071",
      stopOpacity: 1
    },
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d41f74",
      stopOpacity: 1
    },
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d31f76",
      stopOpacity: 1
    },
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d11f79",
      stopOpacity: 1
    },
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d01f7b",
      stopOpacity: 1
    },
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cf1f7e",
      stopOpacity: 1
    },
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cd1f80",
      stopOpacity: 1
    },
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cc1f82",
      stopOpacity: 1
    },
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cb1f85",
      stopOpacity: 1
    },
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c91f87",
      stopOpacity: 1
    },
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c81f8a",
      stopOpacity: 1
    },
    offset: 0.601563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c71f8c",
      stopOpacity: 1
    },
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c51f8f",
      stopOpacity: 1
    },
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c41f91",
      stopOpacity: 1
    },
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c21f93",
      stopOpacity: 1
    },
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c11f96",
      stopOpacity: 1
    },
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c01f98",
      stopOpacity: 1
    },
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#be1f9b",
      stopOpacity: 1
    },
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bd1f9d",
      stopOpacity: 1
    },
    offset: 0.632813
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bc1fa0",
      stopOpacity: 1
    },
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ba1fa2",
      stopOpacity: 1
    },
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b91fa4",
      stopOpacity: 1
    },
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b81fa7",
      stopOpacity: 1
    },
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b620a8",
      stopOpacity: 1
    },
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b420a9",
      stopOpacity: 1
    },
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b221aa",
      stopOpacity: 1
    },
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b022ab",
      stopOpacity: 1
    },
    offset: 0.664063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ae23ac",
      stopOpacity: 1
    },
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ac24ad",
      stopOpacity: 1
    },
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#aa25ae",
      stopOpacity: 1
    },
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a826af",
      stopOpacity: 1
    },
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a727b0",
      stopOpacity: 1
    },
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a528b0",
      stopOpacity: 1
    },
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a329b1",
      stopOpacity: 1
    },
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a12ab2",
      stopOpacity: 1
    },
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9f2bb3",
      stopOpacity: 1
    },
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9d2cb4",
      stopOpacity: 1
    },
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9b2db5",
      stopOpacity: 1
    },
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#992eb6",
      stopOpacity: 1
    },
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#972fb7",
      stopOpacity: 1
    },
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9530b8",
      stopOpacity: 1
    },
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9331b8",
      stopOpacity: 1
    },
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9132b9",
      stopOpacity: 1
    },
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8f33ba",
      stopOpacity: 1
    },
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8e34bb",
      stopOpacity: 1
    },
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8c35bc",
      stopOpacity: 1
    },
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8a36bd",
      stopOpacity: 1
    },
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8837be",
      stopOpacity: 1
    },
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8638bf",
      stopOpacity: 1
    },
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8439bf",
      stopOpacity: 1
    },
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#823ac0",
      stopOpacity: 1
    },
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#803ac1",
      stopOpacity: 1
    },
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#7e3bc2",
      stopOpacity: 1
    },
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#7c3cc3",
      stopOpacity: 1
    },
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#7a3dc4",
      stopOpacity: 1
    },
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#783ec5",
      stopOpacity: 1
    },
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#763fc6",
      stopOpacity: 1
    },
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#7440c7",
      stopOpacity: 1
    },
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#7341c7",
      stopOpacity: 1
    },
    offset: 0.789063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#7142c8",
      stopOpacity: 1
    },
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#6f43c9",
      stopOpacity: 1
    },
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#6d44ca",
      stopOpacity: 1
    },
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#6b45cb",
      stopOpacity: 1
    },
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#6946cc",
      stopOpacity: 1
    },
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#6747cd",
      stopOpacity: 1
    },
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#6548ce",
      stopOpacity: 1
    },
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#6349cf",
      stopOpacity: 1
    },
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#614acf",
      stopOpacity: 1
    },
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#5f4bd0",
      stopOpacity: 1
    },
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#5d4cd1",
      stopOpacity: 1
    },
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#5b4dd2",
      stopOpacity: 1
    },
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#5a4ed3",
      stopOpacity: 1
    },
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#584fd4",
      stopOpacity: 1
    },
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#5650d5",
      stopOpacity: 1
    },
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#5451d6",
      stopOpacity: 1
    },
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#5351d6",
      stopOpacity: 1
    },
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#5351d6",
      stopOpacity: 1
    },
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#5351d6",
      stopOpacity: 1
    },
    offset: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "5210a6f265"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#93b69cd127)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 375,
    y: 0,
    height: 374.999991,
    style: {
      fill: "url(#9052c2a439)",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 237.808594 300.65625 L 137.847656 300.65625 C 103.191406 300.65625 74.996094 272.464844 74.996094 237.808594 L 74.996094 137.847656 C 74.996094 103.191406 103.191406 74.996094 137.847656 74.996094 L 237.808594 74.996094 C 272.464844 74.996094 300.65625 103.191406 300.65625 137.847656 L 300.65625 237.808594 C 300.65625 272.464844 272.464844 300.65625 237.808594 300.65625 Z M 137.847656 90.273438 C 111.617188 90.273438 90.273438 111.617188 90.273438 137.847656 L 90.273438 237.808594 C 90.273438 264.039062 111.617188 285.378906 137.847656 285.378906 L 237.808594 285.378906 C 264.039062 285.378906 285.378906 264.039062 285.378906 237.808594 L 285.378906 137.847656 C 285.378906 111.617188 264.039062 90.273438 237.808594 90.273438 Z M 137.847656 90.273438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 187.832031 243.722656 C 157.015625 243.722656 131.941406 218.648438 131.941406 187.832031 C 131.941406 157.015625 157.015625 131.941406 187.832031 131.941406 C 218.648438 131.941406 243.722656 157.015625 243.722656 187.832031 C 243.722656 218.648438 218.648438 243.722656 187.832031 243.722656 Z M 187.832031 147.214844 C 165.4375 147.214844 147.21875 165.429688 147.21875 187.828125 C 147.21875 210.222656 165.441406 228.441406 187.832031 228.441406 C 210.222656 228.441406 228.445312 210.222656 228.445312 187.828125 C 228.445312 165.429688 210.226562 147.214844 187.832031 147.214844 Z M 187.832031 147.214844 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.de98b0fe72a4d68a62bcc94ab834f580.svg";
export { ForwardRef as ReactComponent };